module.exports = __webpack_public_path__ + "static/media/Resume.9c9d1dd0.png";